import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit"
import { ItemDetail } from "../.."
import { fieldsAPI } from "../../../../apis"
import { addErrorNotification } from "../../../notifications/actions"
import { fetchItemDetail, itemDetailSlice } from "../../slice"
import { updateFieldValue } from "../../../../apis/fields"
import { Fields } from "../../../fields"
import { StatusCode } from "../../../../apis/utils/constants"

export const defaultRequestingContextMenuErrorMessage =
    "Something went wrong when fetching The flow control buttons."

export const panelFooterReducersBuilder = (
    builder: ActionReducerMapBuilder<ItemDetail.ItemDetailState>,
): void => {
    builder
        .addCase(fetchFlowControlButtons.pending, (state) => {
            state.panelFooter.isLoading = true
        })
        .addCase(fetchFlowControlButtons.fulfilled, (state, action) => {
            state.actions = action.payload.actions
            state.panelFooter.isLoading = false
        })
        .addCase(fetchFlowControlButtons.rejected, (state, action) => {
            console.error(action.payload ?? action.error.message)
            state.actions = itemDetailSlice.getInitialState().actions
            state.panelFooter.isLoading = false
        })

        .addCase(clickStateTransitionButtonThunk.pending, (state) => {
            state.panelFooter.isLoading = true
        })
        .addCase(clickStateTransitionButtonThunk.fulfilled, (state) => {
            state.panelFooter.isLoading = false
        })
        .addCase(clickStateTransitionButtonThunk.rejected, (state, action) => {
            console.error(action.payload ?? action.error.message)
            state.panelFooter.isLoading = false
        })
}

export const fetchFlowControlButtons = createAsyncThunk(
    "pageFooter/fetchFlowControlActions",
    async (itemId: number, { rejectWithValue, dispatch }) => {
        try {
            const flowControlButtons =
                await fieldsAPI.collectStateTransitionButtons(itemId)

            return {
                actions: {
                    buttons: flowControlButtons,
                },
            }
        } catch (error) {
            dispatch(
                addErrorNotification(defaultRequestingContextMenuErrorMessage),
            )
            const responseError: Response = error
            if (!(responseError instanceof Response)) {
                throw error
            }
            return rejectWithValue((await responseError.json()).detail)
        }
    },
)

export const clickStateTransitionButtonThunk = createAsyncThunk(
    "pageFooter/clickStateTransitionButton",
    async (
        {
            buttonId,
            itemId,
        }: {
            buttonId: number
            itemId: number
        },
        { dispatch },
    ): Promise<void> => {
        try {
            const statusField: Fields.Field = {
                odataType: "#TF.StatusItemField",
                value: {
                    Id: buttonId,
                },
                type: "status",
                fieldId: StatusCode,
                title: "",
            }
            await updateFieldValue(itemId, statusField)
        } catch (error) {
            let errorMessage = defaultRequestingContextMenuErrorMessage
            if (error instanceof Error) {
                errorMessage = error.message
            }
            dispatch(addErrorNotification(errorMessage))
        } finally {
            dispatch(fetchItemDetail(itemId))
        }
    },
)
